<template>
  <div class="indexCompt">
    <!-- <IndexCompt /> -->
    <index :pageInfo="orderInfo"/>
  </div>
</template>
<script>

import index from '@/view/index.vue'
// import IndexCompt from '@/components/IndexCompt.vue'
export default {
  components: {
    index,
    // IndexCompt
  },
  data() {
    return {
      routeObj: {},
      orderInfo: {
        orderType: '46',
        disabledAndroid: false,
        hasPaySys: 'Y', // 没有支付系统权限(安卓) 
        wxChat: 'https://work.weixin.qq.com/ca/cawcdeaca972858707', // 加微信
      }
    };
  },
  created() {
    this.routeObj = this.$route.query;
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>

</style>